export class ApiCallResult {
  public data: [] | any;
  public loading: boolean;
  public loaded: boolean;
  public success: boolean;
  public display: {};

  constructor(data: any) {
    this.data = data;
    this.display = {};
  }
}

export class ApiCallResultSimulacion extends ApiCallResult {
  public totalAcumulado: number;
  public tieneDatosValidos: boolean;

  constructor(data: any) {
    super(data);
    this.totalAcumulado = 0;
    this.tieneDatosValidos = false;
  }
}
